import React from 'react'

export const About = () => {
  return (
    <div>
      <section>
        <div className='aboutherosection'>

          <div className='abtherocontent'>
            <h1 className='sneakerfont'data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1800">Sneaker</h1>
            <h6 className='menssh'data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1600"> Mens Shoe</h6>
            <h1 className='contentheading'data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1400">New Air Sneaker Streaks</h1>
            <p className='para'data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1200">Lorem ipsum dolor sit amet consectetur adipisicing <br /> Modi dignissimos hic inventore enim vitae vero. <br />Voluptatum culpa voluptas fuga!</p>
            <a href="/product"><button className='herobtn' data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1000">Go to Collection</button></a>
          </div>


          <img src="./images/imageabttt.png" alt="" className='abtheroshoe img-fluid' data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1800"/>

        </div>

      </section>
      <section className='sidespace'>
        <div className='abtstoryflex'>
          <div>
            <img src="./images/image58.png" alt="" className='abtstorycontent img-fluid' data-aos="flip-right"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="2000"/>
          </div>
          <div>
            <h3 className='abtstoryheading' data-aos="fade-down"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">About <span className='spantwo'>AIR JORDAN</span></h3>
            <p className='abtstorypara'> <span className='spanfirst'>Nike, Inc</span>., formerly (1964–71) Blue Ribbon Sports, American sportswear company that is one of the world’s best-known brands.
              It was founded in 1964 as Blue Ribbon Sports by Phil Knight and Bill Bowerman, his former track-and-field coach
              at the University of Oregon. The company was renamed Nike, Inc., in 1971, and it went public in 1980. <span className='spanthree'>By the early 21st century, Nike had retail outlets and distributors in more than 170 countries,
                and its logo—a curved check mark called the “swoosh”—was recognized throughout the world.
                The company is headquartered in Beaverton, Oregon.</span>
            </p>
          </div>
        </div>
      </section>
      <section className='sidespace'>
        <div>
          <h1 className=' patnertxt'>Official <span className='spantwo'>Patners</span> </h1>
          <div className='patnerimages' data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">
             <img src="./images/Rectangle23.png" alt="" className='patnerimg'/>
             <img src="./images/Rectangle24.png" alt="" className='patnerimg'/>
             <img src="./images/Rectangle25.png" alt="" className='patnerimg'/>
             
          </div>
        </div>
      </section>
      <section className='sidespace '>
        <div className='lastctnflex'>
         <div className='neverstopdiv' data-aos="fade-right"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">
          <h1 className='never'>Never Stop It</h1>
          <hr className='abthrline'/>
          <h4 className='abtwords'>Push The Limits Of The Impossible</h4>
          <div>
          <a href="/Product"><button className='abtpushbtn'>Buy Now</button></a>
          </div>
          
         </div>
         <div data-aos="fade-left"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="1500">
          <img src="./images/image59.png" alt=""  className='lastctn'/>
         </div>
        </div>
       
      </section>
      <section className='footerbox'>
  <div className='sidespace'>
    <div className='rowflex'>
    <div>
      <img src="./images/jordanlogo.png" alt="" className='footerlogo'/>
      <p className='footerpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, saepe dolor. Exercitationem commodi eveniet accusantium deserunt ex cumque. ter impedit atque consectetur </p>
      <p className='mailheading'>Receive mail at your mail</p>
      <div className='inputflex'>
      <input type="text" placeholder='Mail id' className='inputbox'/>
      <button className='sendbox'>Send</button>
      </div>
     
     </div>
     <div>
      <h5 className='secondrow'>Products</h5>
      <p className='footersecondrow'>Running shoe</p>
      <p className='footersecond'>Sports shoe</p>
      <p className='footersecond'>Formal shoe</p>
      <p className='footersecond'>Causal shoe</p>
      <p className='footersecond'>Sneakers shoe</p>
     </div>
     <div>
      <h5 className='secondrow'>Support</h5>
      <p className='footersecondrow'>Privacy Policy</p>
      <p className='footersecond'>Terms & Condition</p>
      <p className='footersecond'>Cookies settings</p>
      <p className='footersecond'>Contact us</p>
      <p className='footersecond'>Customer care</p>
     
    
     </div>
     <div>
      <h5 className='secondrow'>Contacts</h5>
     <div className='phoneflex'>
        <p   class='bx bx-phone-call footerphone' ></p>
        <p className='footernumber'> +99 98564 63277</p>
     </div>
     <div className='mailflex'>
        <p   class='bx bx-envelope footerphone' ></p>
        <p className='footernumber'> shoelace@gmail.com</p>
     </div>
     <div className='mailflex'>
        <p   class='bx bx-map footerphone' ></p>
        <p className='footernumber'> 27 B benseroad <br />Newyork USA</p>
     </div>
      </div>
    </div>
    <hr className='footerline'/>
    <div className='downfooterflex'>
      <div className='dfone'>
        <img src="./images/paymentcard.png" alt=""  className='paymentone'/>
        <p className='copyright'>Copyright@Dpdesigner/2023</p>      
      </div>
      <div className='dftwo'>
        <img src="./images/smtwo.png" alt="" className='paymenttwo' />
        <p className='copyright'>All Rights Reserved</p>      
      </div>
    </div>
    
    
  </div>
 </section>
    </div>
  )
}
